import { axiosNT, axiosNTL, axiosUpload } from '../../../services/axios';

const preSignedURL = async (params: any) => {
    return axiosNTL.get('aws/audio', { params })
        .then((res: any) => {
            const { aws }: { aws: any } = res.responseObject || {};
            return Promise.resolve(aws);
        });

}


const uploadAudio = async (file: any, onUploadProgress: any, cancelToken: any, id?: any) => {
    try {
        const awsObject: any = await preSignedURL({ id, contentType: file.name.split('.')[1] });
        if (awsObject && awsObject.signedUrl) {
            await axiosUpload.put(`${awsObject.signedUrl}`, file, {
                headers: {
                    "Content-Type": file.type,
                },
                onUploadProgress,
                cancelToken
            });
            return awsObject.Key;
        }
    } catch (error) {
        return Promise.reject(error);
    }
};
interface deleteAudioThumbnailPayload {
    audioKey?: string,
    id?: string,
    completionPercent?: Number,
};

const deleteAudioService = async (payload : any) => {
    return axiosNT.delete(`audio/`, { params: payload })
        .then((res: any) => {
            return Promise.resolve(res);
        });

};
const audioService = {
    uploadAudio,
    deleteAudioService,
};

export default audioService;